module.exports = __webpack_public_path__ + "static/rotate.74512595.svg";


//////////////////
// WEBPACK FOOTER
// ./src/client/assets/rotate.svg
// module id = 544
// module chunks = 1